import request from '../utils/request-axios'
import api from '../utils/api'

//获取注册验证码
export function getRegCode(params) {
  return request(`${api.getRegCode}${params}`, {
    loading: true,
    method: 'get',
  });
}

//注册
export function register(params) {
  return request(`${api.register}`, {
    loading: true,
    method: 'post',
    data: params,
    promptMessage: "注册成功!",
  });
}




// WEBPACK FOOTER //
// ./src/services/register.js